export function getCallbackRequestKey(code: string, state: string) {
  return `oauth_callback_request:${state}:${code}`;
}

export type OAuthCallbackParams = {
  code: string | null;
  state: string | null;
  error: string | null;
  errorDescription: string | null;
};

export type OAuthCallbackParseResult =
  | { kind: 'error'; message: string }
  | { kind: 'missing' }
  | { kind: 'ready'; code: string; state: string };

export function parseOAuthCallbackParams(params: OAuthCallbackParams): OAuthCallbackParseResult {
  if (params.error) {
    return {
      kind: 'error',
      message: `Authentication error: ${params.errorDescription || params.error}`,
    };
  }

  if (!params.code || !params.state) {
    return { kind: 'missing' };
  }

  return { kind: 'ready', code: params.code, state: params.state };
}

export function shouldSkipDuplicateCallback(sessionStorage: Storage, key: string): boolean {
  const value = sessionStorage.getItem(key);
  return value === 'processing' || value === 'done';
}

export type OAuthCallbackSuccessPayload = {
  token: string;
  access_token?: string;
  id_token?: string;
  user: Record<string, unknown>;
};

export function persistOAuthSession(
  storage: { localStorage: Storage; sessionStorage: Storage },
  callbackRequestKey: string,
  data: OAuthCallbackSuccessPayload,
) {
  storage.localStorage.setItem('auth_token', data.token);
  if (data.access_token) {
    storage.localStorage.setItem('access_token', data.access_token);
  }
  if (data.id_token) {
    storage.localStorage.setItem('id_token', data.id_token);
  }
  storage.localStorage.setItem('user', JSON.stringify(data.user));
  storage.localStorage.removeItem('explicit_logout');
  storage.sessionStorage.removeItem('explicit_logout');
  storage.sessionStorage.setItem(callbackRequestKey, 'done');
}

export function clearCallbackRequestState(sessionStorage: Storage, key: string) {
  sessionStorage.removeItem(key);
}
